import { jsx, jsxs } from 'react/jsx-runtime';
import { IconChevronDown } from '@fabric-app/icons/old';
import { ButtonIcon } from '@fabric-app/ui/components/Button';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import { styled } from 'styled-components';
import { DropdownItemContentName } from './DropdownItemContent.js';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';

const Container = styled.div.withConfig({
  displayName: "DropdownItemComponent__Container",
  componentId: "sc-4e2c3687-0"
})([
  `position:relative;display:flex;align-items:flex-start;gap:0.5em;margin-left:-0.55em;`,
  `{z-index:1;}`,
  ` svg{transform:rotate(-90deg);transition:transform 0.2s ease-in-out;}&[data-expanded='true']{> `,
  ` svg{transform:rotate(0deg);}}&[data-empty-content='true']{> `,
  ` svg{opacity:0.4;}}`
], ButtonIcon, ButtonIcon, ButtonIcon, ButtonIcon);
const EmptyContent = styled.div.withConfig({
  displayName: "DropdownItemComponent__EmptyContent",
  componentId: "sc-4e2c3687-1"
})([
  `z-index:0;position:relative;background:transparent;cursor:pointer;&::after{content:'Empty toggle. Click or drop content inside';color:`,
  `;}&::before{z-index:-1;content:'';position:absolute;top:-0.1em;left:-0.1em;width:calc(100% + 0.2em);height:calc(100% + 0.2em);border-radius:0.25em;background:transparent;transition:background 0.2s ease-in-out;}`,
  `{&:hover{&::before{background:`,
  `;}}}`
], cssVar["color-text-tertiary"], mediaHover, cssVar["color-bg-tertiary"]);
const InnerContainer = styled.div.withConfig({
  displayName: "DropdownItemComponent__InnerContainer",
  componentId: "sc-4e2c3687-2"
})([
  `display:flex;flex-direction:column;gap:0.5em;`,
  `{display:none;}[data-node-type='`,
  `']{margin-top:0.5em;}> [data-node-view-content] > [data-node-view-content-react] > [data-node-type='`,
  `']{display:none;}[data-expanded='true'] > &{> `,
  `{display:block;}> [data-node-view-content] > [data-node-view-content-react] > [data-node-type='`,
  `']{display:block;> * + *{margin-top:0.75em;}}}`
], EmptyContent, DropdownItemContentName, DropdownItemContentName, EmptyContent, DropdownItemContentName);
const DropdownItemComponent = ({ node, editor, updateAttributes, getPos }) => {
  const expanded = Boolean(node.attrs.expanded);
  const onClick = () => {
    if (!editor.isEditable) return;
    updateAttributes({
      expanded: !expanded
    });
  };
  const onClickEmpty = () => {
    const targetPos = getPos() + node.nodeSize - 1;
    const paragraph = editor.schema.nodes.paragraph.create({}, []);
    const content = editor.schema.nodes.dropdownItemContent.create({}, [
      paragraph
    ]);
    editor.chain().insertContentAt(targetPos, content).setTextSelection(targetPos + 1).run();
  };
  return /* @__PURE__ */ jsx(NodeViewWrapper, {
    children: /* @__PURE__ */ jsxs(Container, {
      "data-expanded": expanded,
      "data-empty-content": node.childCount === 1,
      children: [
        /* @__PURE__ */ jsx(ButtonIcon, {
          size: "xss",
          onClick,
          children: /* @__PURE__ */ jsx(IconChevronDown, {})
        }),
        /* @__PURE__ */ jsxs(InnerContainer, {
          children: [
            /* @__PURE__ */ jsx(NodeViewContent, {
              as: "div"
            }),
            node.childCount === 1 && /* @__PURE__ */ jsx(EmptyContent, {
              onClick: onClickEmpty,
              "data-dropdown-item-empty-container": true
            })
          ]
        })
      ]
    })
  });
};

export { DropdownItemComponent };
//# sourceMappingURL=DropdownItemComponent.js.map
